// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2937":"eabe11fc","7034":"210f95f9"}[chunkId] || chunkId) + "." + {"1167":"ce38dc0334eb9be9","2937":"0a588ce09fb27a14","6936":"7813d8dcca20c2ab","7034":"f1f7d7c19599a0bc"}[chunkId] + ".js";
};